import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import GroupModal from 'components/GroupModal';
// @ts-ignore
import HarvestSchemaExistsGate from 'components/HarvestSchemaExistsGate';
// @ts-ignore
import EventPrintDialog from './components/EventPrintDialog';
import PickSchedule from './scenes/PickSchedule';
import BinForecasts from './scenes/BinForecasts';
import BinCheckReport from './scenes/BinCheckReport';
import QualityReport from './scenes/QualityReport';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Harvest = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Harvest"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                Harvest -
                {' '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <HarvestSchemaExistsGate
            FallbackComponent={<Redirect to="/organization/workforce" />}
        >
            <Switch>
                <Redirect
                    exact
                    from="/organization/harvest"
                    to="/organization/harvest/pick-schedule"
                />
                <Route
                    exact
                    path="/organization/harvest/pick-schedule"
                    component={PickSchedule}
                />
                <Route
                    exact
                    path="/organization/harvest/bin-forecasts"
                    component={BinForecasts}
                />
                <Route
                    exact
                    path="/organization/harvest/quality-report"
                    component={QualityReport}
                />
                <Route
                    exact
                    path="/organization/harvest/bin-check-report"
                    component={BinCheckReport}
                />
                <Redirect
                    from="/organization/harvest/*"
                    to="/organization/harvest/pick-schedule"
                />
            </Switch>
        </HarvestSchemaExistsGate>
        <EventPrintDialog />
        <GroupModal />
    </ErrorBoundary>
);

export default Harvest;
